import React from "react";

const SuccessIcon = (props) => {
	return (
		<svg
			width="30"
			height="29"
			viewBox="0 0 30 29"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M14.9987 27.7904C22.3395 27.7904 28.2904 21.8395 28.2904 14.4987C28.2904 7.15791 22.3395 1.20703 14.9987 1.20703C7.65791 1.20703 1.70703 7.15791 1.70703 14.4987C1.70703 21.8395 7.65791 27.7904 14.9987 27.7904ZM9.26168 9.47902C9.43524 9.1319 9.89857 8.45715 10.7697 8.45715C11.6407 8.45715 12.1041 9.1319 12.2776 9.47902C12.4873 9.89841 12.5822 10.3932 12.5822 10.8738C12.5822 11.3544 12.4873 11.8492 12.2776 12.2686C12.1041 12.6157 11.6407 13.2905 10.7697 13.2905C9.89857 13.2905 9.43524 12.6157 9.26168 12.2686C9.05198 11.8492 8.95715 11.3544 8.95715 10.8738C8.95715 10.3932 9.05198 9.89841 9.26168 9.47902ZM17.72 9.47902C17.8936 9.1319 18.3569 8.45715 19.228 8.45715C20.0991 8.45715 20.5624 9.1319 20.736 9.47902C20.9457 9.89841 21.0405 10.3932 21.0405 10.8738C21.0405 11.3544 20.9457 11.8492 20.736 12.2686C20.5624 12.6157 20.0991 13.2905 19.228 13.2905C18.3569 13.2905 17.8936 12.6157 17.72 12.2686C17.5103 11.8492 17.4155 11.3544 17.4155 10.8738C17.4155 10.3932 17.5103 9.89841 17.72 9.47902ZM20.2874 19.5094L19.8307 18.7266C20.2874 19.5094 20.2871 19.5095 20.2869 19.5096L20.2864 19.5099L20.2852 19.5106L20.2823 19.5123L20.2741 19.517L20.2487 19.5313C20.2278 19.543 20.1989 19.5589 20.1623 19.5784C20.0894 19.6172 19.9857 19.6705 19.8543 19.7332C19.5916 19.8586 19.2159 20.0227 18.7492 20.1861C17.8192 20.5116 16.5073 20.8411 14.9974 20.8411C13.4875 20.8411 12.1756 20.5116 11.2456 20.1861C10.7789 20.0227 10.4032 19.8586 10.1405 19.7332C10.009 19.6705 9.90544 19.6172 9.83244 19.5784C9.79593 19.5589 9.76704 19.543 9.7461 19.5313L9.72069 19.517L9.71252 19.5123L9.70959 19.5106L9.70841 19.5099L9.7079 19.5096C9.70766 19.5095 9.70743 19.5094 10.1641 18.7266L10.6207 17.9438L10.6299 17.9489C10.6407 17.9549 10.659 17.965 10.6845 17.9786C10.7356 18.0058 10.8154 18.047 10.9212 18.0975C11.1333 18.1987 11.448 18.3366 11.8444 18.4754C12.6406 18.754 13.7454 19.0286 14.9974 19.0286C16.2494 19.0286 17.3542 18.754 18.1504 18.4754C18.5468 18.3366 18.8615 18.1987 19.0736 18.0975C19.1794 18.047 19.2592 18.0058 19.3103 17.9786C19.3358 17.965 19.3541 17.9549 19.3649 17.9489L19.3745 17.9435C19.8068 17.6917 20.3614 17.8377 20.6135 18.2699C20.8657 18.7023 20.7197 19.2572 20.2874 19.5094ZM10.6203 17.9435L10.6199 17.9433L10.6199 17.9433L10.6188 17.9427C10.1868 17.692 9.63309 17.8382 9.38126 18.2699C9.12907 18.7023 9.2751 19.2572 9.70743 19.5094L10.1641 18.7266C10.6207 17.9438 10.6205 17.9436 10.6203 17.9435Z"
				fill="url(#paint0_linear_4506_246544)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_4506_246544"
					x1="14.9987"
					y1="1.20703"
					x2="14.9987"
					y2="27.7904"
					gradientUnits="userSpaceOnUse">
					<stop stop-color="#18BB0C" />
					<stop
						offset="1"
						stop-color="#067306"
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default SuccessIcon;
